import { type FC, memo } from 'react';

import { translations } from './SelectLanguage';
import { productsLV } from '../translations/productsLV';
import { productsRU } from '../translations/productsRU';
import type { Language, ProductColor, Result } from '../types';

import './Slide.css';
import { renderImage } from '../ImageMap';

interface SlideProps {
    language: Language;
    product: string;
    updateList: (result: Result) => void;
    changeSlide: () => void;
    hasImage: boolean;
}

export const Slide: FC<SlideProps> = memo(({product, updateList, changeSlide, language, hasImage}) => {
    const saveResult = (color: ProductColor) => {
        updateList({
            product: product,
            color: color,
        });
        changeSlide();
    }

    return (
        <div className="slide">
            <div className={hasImage ? "slideTitle slideTitleWithImage" : "slideTitle"}>
                <div className="chooseColor">{translations.chooseColorOfProduct} </div>
                <div className={hasImage ? "productNameWithImage" : "productName"}>{language === "lv"
                    ? productsLV[product]
                    : productsRU[product]
                }</div>
                {hasImage && renderImage(product)}
            </div>
            <div className="buttonContainer">
                <div
                    className="button"
                    onClick={() => saveResult("green")}
                    style={{background: "green"}}
                >
                    <span>{translations.green}</span>
                </div>
                <div
                    className="button"
                    style={{background: "yellow"}}
                    onClick={() => saveResult("yellow")}
                >
                    <span>{translations.yellow}</span>
                </div>
                <div
                    className="button"
                    style={{background: "red"}}
                    onClick={() => saveResult("red")}
                >
                    <span>{translations.red}</span>
                </div>
            </div>
        </div>
  );
});
